var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.texts),function(item,i){return [_vm._v(_vm._s(item)),(i < _vm.texts.length - 1)?_c('em',{key:i,staticClass:"v-text-keywords"},[_vm._v(_vm._s(_vm.keyword_trim))]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }